import $ from 'jquery'

import { Util } from 'bootstrap'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'formtabs'
const DATA_KEY = `opp.${NAME}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const ClassName = {
  ACTIVE: 'active'
}

const Selector = {
  DATA_TOGGLE_FORM_TABS: '[data-toggle="form-tabs"] > [data-toggle="tab"]',
  FIELDSET_CHILD: '> fieldset' // N.B. :scope pseudo-class not supported in IE
}

const Event = {
  BS_TAB_SHOWN_HIDDEN: 'shown.bs.tab hidden.bs.tab'
}

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class FormTab {
  constructor(element) {
    this._element = element
    this._tabPaneElem = this._getTabPaneElem()
    this._fieldsetElems = this._getFieldsetElems()
    this._addEventListeners()
  }

  // Public

  update() {
    this._updateFieldsetElems()
  }

  enable() {
    this._enableFieldsetElems()
  }

  disable() {
    this._disableFieldsetElems()
  }

  // Private

  _getTabPaneElem() {
    const selector = Util.getSelectorFromElement(this._element)
    return selector && document.querySelector(selector)
  }

  _getFieldsetElems() {
    const elem = this._tabPaneElem
    return elem ? [...$(elem).find(Selector.FIELDSET_CHILD)] : []
  }

  _updateFieldsetElems() {
    if (this._isActive()) {
      this._enableFieldsetElems()
    } else {
      this._disableFieldsetElems()
    }
  }

  _isActive() {
    return this._element.classList.contains(ClassName.ACTIVE)
  }

  _enableFieldsetElems() {
    for (const elem of this._fieldsetElems) {
      elem.disabled = false
    }
  }

  _disableFieldsetElems() {
    for (const elem of this._fieldsetElems) {
      elem.disabled = true
    }
  }

  _addEventListeners() {
    $(this._element).on(Event.BS_TAB_SHOWN_HIDDEN, () => this.update() || true)
  }

  // Static

  static _jQueryInterface(config, ...args) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = new FormTab(this, config)
        $(this).data(DATA_KEY, data)
      }

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`)
        }

        data[config](...args)
      }
    })
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

// Update on load to be sure form tab state is accurate.
FormTab._jQueryInterface.call($(Selector.DATA_TOGGLE_FORM_TABS), 'update')

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = FormTab._jQueryInterface
$.fn[NAME].Constructor = FormTab
$.fn[NAME].noConflict = () => {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return FormTab._jQueryInterface
}

export default FormTab
